import SingleVehicleMap from "./SingleVehicleMap";

// Wrapper page so we can add a dedicated route for the split (half map + bottom UI) mobile layout
// without changing existing map/marker/play logic.
export default function SingleVehicleMapHalfUI() {
  return <SingleVehicleMap />;
}

